import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AccountService } from '../account.service';

@Component({
  selector: 'pv-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  disabled_d2c = (window as any).disabled_d2c;

  constructor(
    private meta: Meta,
    private title: Title,
    private router: Router,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.title.setTitle(`Login - ${this.accountService.account.name}`)

    if (this.disabled_d2c) {
      this.router.navigate(['/wholesale-login'])
    }
  }

}
